import { render, staticRenderFns } from "./CompareView.vue?vue&type=template&id=391ca313&"
import script from "./CompareView.ts?vue&type=script&lang=ts&"
export * from "./CompareView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports